// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2s_e-wUqqjcZuOyk9rnccZ:hover rect {\n  fill: #FFBE00;\n}\n._2s_e-wUqqjcZuOyk9rnccZ:active rect {\n  fill: #BEBEBE;\n}\n", ""]);
// Exports
exports.locals = {
	"button": "_2s_e-wUqqjcZuOyk9rnccZ"
};
module.exports = exports;
